const DEFAULT_CHART_PADDING = 1.2;
const DEFAULT_ENV_MAP_URL = 'img/adams_place_bridge_512.hdr';

const THEME_ORANGE_PINK = 'orange-pink';
const THEME_BLUE_PURPLE = 'blue-purple';

const LAYOUT_SIMPLE = 'simple';
const LAYOUT_FANCY = 'fancy';

const MIN_BAR_HEIGHT = 0;
const MAX_BAR_HEIGHT = 30;

const GRADIENT_ORANGE_PINK = 'orange-pink';
const GRADIENT_BLUE_PURPLE = 'blue-purple';
const GRADIENT_PINK_PURPLE = 'pink-purple';
const GRADIENT_GRAY = 'gray';

const BASE_RENDER_LAYER = 0;
const BLOOM_RENDER_LAYER = 1;

export {
  DEFAULT_CHART_PADDING,
  DEFAULT_ENV_MAP_URL,
  LAYOUT_FANCY,
  LAYOUT_SIMPLE,
  MIN_BAR_HEIGHT,
  MAX_BAR_HEIGHT,
  THEME_BLUE_PURPLE,
  THEME_ORANGE_PINK,
  GRADIENT_ORANGE_PINK,
  GRADIENT_BLUE_PURPLE,
  GRADIENT_PINK_PURPLE,
  GRADIENT_GRAY,
  BASE_RENDER_LAYER,
  BLOOM_RENDER_LAYER,
};
